document.addEventListener('DOMContentLoaded', function () {

  const slider = document.querySelector('.nas-slider');
  const prevBtn = document.querySelector('.nas-prev');
  const nextBtn = document.querySelector('.nas-next');

  if (!slider) return;

  const getScrollAmount = () => {
    const card = slider.querySelector('.nas-card');
    if (!card) return 350;

    const gap = 16;
    return card.offsetWidth + gap;
  };

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      slider.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });
  }

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;

    slider.scrollLeft = scrollLeft - walk;
  });

  let autoSlide;

  function startAutoSlide() {

    if (window.innerWidth <= 768) return;

    autoSlide = setInterval(() => {

      const maxScroll =
        slider.scrollWidth - slider.clientWidth;

      if (
        slider.scrollLeft >= maxScroll - 10
      ) {
        slider.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      }

    }, 4000);

  }

  function stopAutoSlide() {
    clearInterval(autoSlide);
  }

  startAutoSlide();

  slider.addEventListener('mouseenter', stopAutoSlide);
  slider.addEventListener('mouseleave', startAutoSlide);

});